import { NgModule, isDevMode } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreloadSelectedModules } from './preload-selected-modules';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';
import { LineAuthComponent } from './components/line-auth/line-auth.component';
import { GoogleAuthComponent } from './components/google-auth/google-auth.component';
import { LazadaECommerceCallbackComponent } from './components/lazada-e-commerce-callback/lazada-e-commerce-callback.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { adminGuard } from './modules/core/guards/admin.guard';
import { growerGuard } from './modules/core/guards/grower.guard';
import { superadminGuard } from './modules/core/guards/superadmin.guard';
import { SupplierDetailsComponent } from './modules/public/components/supplier-details/supplier-details.component';
import { VerifyLoginTokenComponent } from './components/verify-login-token/verify-login-token.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';

const routes: Routes = [

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, data: { showHeader: false, showFooter: false } },
  { path: 'line-auth-callback', component: LineAuthComponent, data: { showHeader: false, showFooter: false } },
  { path: 'google-auth-callback', component: GoogleAuthComponent, data: { showHeader: false, showFooter: false } },
  { path: 'lazada-e-commerce-callback', component: LazadaECommerceCallbackComponent, data: { showHeader: false, showFooter: false } },
  { path: 'forget-password', component: ForgetPasswordComponent, data: { showHeader: false, showFooter: false, } },
  { path: 'reset-password/:token', component: ResetPasswordComponent, data: { showHeader: false, showFooter: false,}  },
  { path: 'verify-account/:uuid', component: LoginComponent },
  { path: 'supplier-verification', component: SupplierDetailsComponent, data: { showHeader: false, showFooter: false } },
  { path: 'verify-login-token', component: VerifyLoginTokenComponent, data: { showHeader: false, showFooter: false } },

  
  {
    path: 'public', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
    canActivate: [], data: { preload: true, delay: 2000 }
  },
  {
    path: 'p', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
    canActivate: [], data: { preload: true, delay: 2000 }
  },
  {
    path: 'self-service', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
    canActivate: [], data: { preload: true, delay: 2000 }
  },
  
  {
    path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [adminGuard], data: { preload: true }
  },

  {
    path: 'grower', loadChildren: () => import('./modules/grower/grower.module').then(m => m.GrowerModule),
    canActivate: [growerGuard], data: { preload: true }
  },

  {
    path: 'superadmin', loadChildren: () => import('./modules/superadmin/superadmin.module').then(m => m.SuperadminModule),
    canActivate: [superadminGuard], data: { preload: true, delay: 2000 }
  },
  { path: 'not-found', pathMatch: 'full', component: NotFoundComponent, data: { showHeader: false, showFooter: false } },
  { path: '**', pathMatch: 'full', redirectTo: '/not-found' },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      {
        useHash: false,
        preloadingStrategy: !isDevMode() ? PreloadSelectedModules : null,
        scrollPositionRestoration: 'enabled'
      }
    ),
  ],
  exports: [RouterModule],
  providers: [PreloadSelectedModules],
})
export class AppRoutingModule { }
